<template lang="pug">
  .clientContactDetail.grey.lighten-5.text-xs-left(v-rc-loader="!ready")
    router-view(v-if="['client_prestataire_contact', 'client_sit_sheets_detail'].includes(routeName)")
    v-layout.pa-4(v-else)
      v-flex.elevation-2.white(v-if="client" :class="hasSomePermissions ? 'xs3 mr-4' : 'lg3 xs12'")
        v-layout.column.client-content-block
          rc-client(
            contactType="client"
            :client="client" title="COMPTE"
            ref="client"
          )
            v-layout.justify-end.px-2(slot="appendActions")
              v-dialog(v-model="dialog" persistent max-width="450")
                v-btn.error.mr-0.mb-2(flat dark slot="activator") Supprimer
                v-card
                  v-card-title.headline Confirmer la suppression.
                  v-card-text Cette opération ne pourra pas être annulée.
                  v-card-actions
                    v-spacer
                    v-btn(color="grey" dark depressed @click.native="dialog = false") Annuler
                    v-btn(
                      color="error"
                      depressed
                      @click.native="dialog = false"
                      @click="deleteClient") Confirmer
      v-flex.xs9.white.elevation-2(v-if="hasSomePermissions")
        v-layout.fill-height
          v-flex.fill-height.client-content-block
            rc-tab-nav.mx-4(:menu="menu" :baseRoutes="['client_prestataire_detail']")
            div.pa-4(style="height: calc(100% - 48px);")
              router-view(v-if="ready")
</template>

<script>
import RcUserRoles from '@/components/RcUserRoles/RcUserRoles.vue';
import RcUserRolesHistory from '@/components/RcUserRoles/RcUserRolesHistory.vue';
import RcClientsContactList from '@/components/RcClients/RcClientsContactList.vue';
import RcClient from '@/components/RcClient/RcClient.vue';
import RcProducts from '@/components/RcClients/RcProducts.vue';
import RcCustomFields from '@/components/RcClients/RcCustomFields.vue';
import RcClientContacts from '@/components/RcClientContacts/RcClientContacts.vue';
import RcNavigationTree from '@/components/RcNavigationTree.vue';
import RcTabNav from '@/components/RcTabNav.vue';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import apiClientService from '@/services/api/ambassador/clientService'

export default {
  components: {
    RcClient,
    RcUserRoles,
    RcClientsContactList,
    RcClientContacts,
    RcProducts,
    RcCustomFields,
    RcUserRolesHistory,
    RcNavigationTree,
    RcTabNav,
  },
  data() {
    return {
      dialog: false,
      customActions: [
        { icon: 'delete', eventKey: 'unbinded' },
      ],
      customFieldsLoading: false,
      ready: false,
      menu: [
        {
          title: 'Contacts',
          route: 'client_contacts',
          permissions: ['mes_utilisateurs_onglet_contacts'],
        },
        ...(this.$store.state.app.destination.id === 1 ? [
          {
            title: 'Produits',
            route: 'client_products',
            permissions: ['mes_utilisateurs_onglet_produits'],
          },
        ] : []),
        //this.$route.params.clientId != this.$store.state.app.destination.id || 
        {
          title: "Gestion des droits",
          route: 'client_roles',
          permissions: ['mes_utilisateurs_onglet_client_roles'],
        },
      ],
    };
  },
  methods: {
    async deleteClient() {
      this.ready = false;
      await apiClientService.deleteById(this.client.id);
      await this.$store.dispatch('clients/getSearchTypes');
      this.$router.push({ name: 'clients_prestataires_list' });
    },
    editCustomValues(newValues) {
      const newData = cloneDeep(this.client);
      newData.customValues = newValues;
      this.saveClient(newData);
    },
    saveClient(newClient) {
      this.$store.dispatch('clients/saveClient', { clientId: this.$route.params.clientId, newClient })
        .catch(() => {
          this.$store.dispatch('errorHandler/throwError', { detail: "Il y a eu un problème avec l'édition du compte." });
        });
    },
    doubleBack() {
      if (this.$route.name === 'client_prestataire_detail') {
        history.go(-1);
      }
    },
  },
  computed: {
    hasSomePermissions() {
      return this.menu.some(route => !route.permissions || !route.permissions.length || route.permissions.every(it => !!this.$store.state.app.user.roles.find(x => x === it)));
    },
    loaded() {
      return ['client'].every(it => this.$refs[it] && this.$refs[it].loaded);
    },
    atLeastOneField() {
      return this.$store.state.customFields.touristic_provider && this.$store.state.customFields.touristic_provider.length;
    },
    routeName() {
      return this.$route.name;
    },
    address() {
      const properties = ['street', 'zip', 'city'];
      const adress = Object.entries(this.client)
        .filter(it => properties.includes(it[0]) && it[1])
        .map(it => it[1])
        .join(', ');
      return adress;
    },
    client() {
      return this.$store.state.clients.selectedClient;
    },
  },
  mounted() {
    window.addEventListener('popstate', this.doubleBack);
    this.$store.dispatch('clients/getClient', { clientId: this.$route.params.clientId }).then(() => {
      this.$nextTick(() => {
        if (!(this.client.touristic_provider === false)) {
          this.menu.push({
            title: 'Fiches',
            route: 'client_sheets',
            permissions: ['mes_utilisateurs_onglet_fiches_sit'],
          });
        }
        this.ready = true;
      })
    });
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.doubleBack);
  },
  destroyed() {
    this.$store.dispatch('clients/setSelected', null);
  },
};
</script>

<style lang="scss">
  .client-content-block {
    height: calc(100vh - (var(--main-navigation-height) + 24px) - 24px);
    overflow-y: auto;
  }
  .clientContactDetail {
    height: calc(100vh - var(--main-navigation-height));
    overflow-y: auto;
  }
  .available-sheets {
    .v-window {
      height: calc(100% - 48px);
      .v-window__container {
        height: 100%;
        .v-window-item {
          height: 100%;
          .sheets-list {
            height: calc(100% - 56px);
            overflow-y: auto;
            .sheet-list-item {
              cursor: pointer;
              &:hover{
                background-color: #efefef;
              }
              border-bottom: 1px solid lightgrey;
              .sheet-thumb-wrapper {
                width: 250px;
              }
              .no-image {
                height: 150px;
                background-image: url('https://www.freeiconspng.com/uploads/no-image-icon-6.png');
                background-position: center;
                background-size: contain;
              }
              &:first-of-type {
                border-top: 1px solid lightgrey;
              }
            }
          }
        }
      }
    }
    .v-tabs__item {
      &.v-tabs__item--active {
        border-bottom: 2px solid var(--primary);
      }
      &:not(.v-tabs__item--active) {
        padding-bottom: 8px;
      }
      transition: border-bottom 0s;
    }
  }
  .rc-roles-wrapper {
    height: 280px;
  }
</style>
